/* Tasador de recompra Fixel — sin dependencias.
 *
 * El cuestionario NO esta escrito aqui: se descarga del backend, de forma que
 * anadir o cambiar una pregunta no obliga a tocar el tema de Shopify.
 * El precio tampoco se calcula aqui: se pide siempre al servidor.
 */
(function () {
  'use strict';

  var TIENDAS_FALLBACK = ['Bravo Murillo', 'San Bernardo'];

  // Desde el punto de vista del cliente, "el servicio esta cerrado", "el
  // backend no responde" y "todavia no esta desplegado" son la misma cosa: no
  // puede vender su movil ahora mismo. Un unico mensaje util para los tres,
  // en vez de un error tecnico que no le dice que hacer.
  var MENSAJE_NO_DISPONIBLE =
    'La tasación online no está disponible en este momento. ' +
    'Escríbenos por WhatsApp o pásate por cualquiera de nuestras tiendas y ' +
    'te valoramos el dispositivo en mano.';

  function init(root) {
    if (root.dataset.fxReady) return;
    root.dataset.fxReady = '1';

    var api = (root.dataset.api || '').replace(/\/+$/, '');
    var el = function (sel) { return root.querySelector(sel); };
    var state = {
      modelo: null,      // {slug, marca, modelo, capacidades}
      preguntas: [],
      idx: -1,           // -1 = pantalla de busqueda
      respuestas: {},
      tiendas: TIENDAS_FALLBACK,
      validez: 14,
      oferta: null,
      inicio: Date.now()
    };

    var pane = el('[data-fx-pane]');
    var bar = el('[data-fx-bar]');
    var label = el('[data-fx-label]');

    // ---------------------------------------------------------------- red
    // Una respuesta que no es JSON (404 con HTML, 502 de nginx, panel en
    // mantenimiento) se traduce a "no disponible" en vez de reventar.
    function leer(r) {
      var tipo = r.headers.get('Content-Type') || '';
      if (tipo.indexOf('json') === -1) {
        return { ok: false, cerrado: true, error: MENSAJE_NO_DISPONIBLE };
      }
      return r.json().catch(function () {
        return { ok: false, cerrado: true, error: MENSAJE_NO_DISPONIBLE };
      });
    }

    function get(path) {
      return fetch(api + path, { headers: { Accept: 'application/json' } }).then(leer);
    }
    function post(path, body) {
      return fetch(api + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(leer);
    }

    // ------------------------------------------------------------- helpers
    function h(tag, attrs, children) {
      var node = document.createElement(tag);
      Object.keys(attrs || {}).forEach(function (k) {
        if (k === 'text') node.textContent = attrs[k];
        else if (k === 'html') node.innerHTML = attrs[k];
        else node.setAttribute(k, attrs[k]);
      });
      (children || []).forEach(function (c) { if (c) node.appendChild(c); });
      return node;
    }

    // "Xiaomi 15" o "Apple Watch Series 10" ya llevan la marca dentro, asi que
    // anteponerla da "Xiaomi Xiaomi 15". Solo se prefija cuando aporta algo.
    function nombreModelo(m) {
      var modelo = m.modelo || '';
      var marca = m.marca || '';
      if (!marca) return modelo;
      if (modelo.toLowerCase().indexOf(marca.toLowerCase()) === 0) return modelo;
      return marca + ' ' + modelo;
    }

    function progreso() {
      var total = state.preguntas.length + 1;
      var hecho = Math.max(0, state.idx + 1);
      bar.style.width = (total ? (hecho / total) * 100 : 0) + '%';
      label.textContent = state.idx < 0
        ? 'Elige tu modelo'
        : 'Paso ' + Math.min(hecho, total) + ' de ' + total;
    }

    function pintar(nodes) {
      pane.innerHTML = '';
      nodes.forEach(function (n) { pane.appendChild(n); });
      progreso();
      var foco = pane.querySelector('input, button');
      if (foco && state.idx >= 0) foco.focus({ preventScroll: true });
    }

    function nav(botones) {
      var wrap = h('div', { class: 'fx-nav' });
      botones.forEach(function (b) { wrap.appendChild(b); });
      return wrap;
    }

    function btn(texto, clase, onClick, attrs) {
      var b = h('button', Object.assign({ type: 'button', class: clase, text: texto }, attrs || {}));
      b.addEventListener('click', onClick);
      return b;
    }

    // ------------------------------------------------------ paso: busqueda
    var buscarTimer = null;

    function pantallaBusqueda() {
      var input = h('input', {
        class: 'fx-input', type: 'search', autocomplete: 'off',
        placeholder: 'Escribe tu modelo. Por ejemplo: iPhone 13',
        'aria-label': 'Buscar modelo'
      });
      var resultados = h('div', { class: 'fx-results' });
      var tipos = h('div', { class: 'fx-chips' });
      var marcas = h('div', { class: 'fx-brands' });
      var tipoActivo = null;
      var marcaActiva = null;

      // Iconos en SVG y no emoji: no existe emoji de tablet en Unicode, y los
      // que se le parecen no los dibujan todas las fuentes. Asi heredan el
      // color del texto y escalan con el.
      function svg(cuerpo) {
        return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
               'stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" ' +
               'aria-hidden="true">' + cuerpo + '</svg>';
      }
      var ICONO = {
        'Móvil': svg('<rect x="7" y="2" width="10" height="20" rx="2.5"/>' +
                     '<line x1="10.5" y1="19" x2="13.5" y2="19"/>'),
        'Tablet': svg('<rect x="3.5" y="3" width="17" height="18" rx="2.5"/>' +
                      '<line x1="10.5" y1="18" x2="13.5" y2="18"/>'),
        'Portátil': svg('<rect x="3.5" y="5" width="17" height="11" rx="1.8"/>' +
                        '<line x1="2" y1="19" x2="22" y2="19"/>'),
        'Reloj': svg('<circle cx="12" cy="12" r="6"/>' +
                     '<path d="M9 6.2 9.6 3h4.8l.6 3.2"/>' +
                     '<path d="M9 17.8 9.6 21h4.8l.6-3.2"/>'),
        'Auriculares': svg('<path d="M4 14v-2a8 8 0 0 1 16 0v2"/>' +
                           '<rect x="2.5" y="13.5" width="4" height="7" rx="2"/>' +
                           '<rect x="17.5" y="13.5" width="4" height="7" rx="2"/>')
      };

      // Dos filas de filtros: primero qué aparato es, luego de qué marca. Es
      // más rápido tocar "Tablet" que escribirlo, y de paso el cliente
      // descubre que compramos más cosas de las que suponía.
      function pintarCategorias() {
        var url = '/api/recompra/categorias';
        if (tipoActivo) url += '?tipo=' + encodeURIComponent(tipoActivo);
        get(url).then(function (data) {
          if (!data || !data.ok) return;

          tipos.innerHTML = '';
          (data.tipos || []).forEach(function (t) {
            var activo = tipoActivo === t.tipo;
            var chip = h('button', {
              type: 'button', class: 'fx-chip', 'aria-pressed': activo ? 'true' : 'false'
            }, [
              h('span', {
                class: 'fx-chip-ico', 'aria-hidden': 'true',
                html: ICONO[t.tipo] || ICONO['Móvil']
              }),
              h('span', { text: t.tipo })
            ]);
            chip.addEventListener('click', function () {
              tipoActivo = activo ? null : t.tipo;
              marcaActiva = null;   // cambiar de tipo invalida la marca elegida
              input.value = '';
              pintarCategorias();
              buscar('');
            });
            tipos.appendChild(chip);
          });

          marcas.innerHTML = '';
          (data.marcas || []).forEach(function (m) {
            var chip = h('button', {
              type: 'button', class: 'fx-brand',
              'aria-pressed': marcaActiva === m.marca ? 'true' : 'false'
            }, [
              h('span', { class: 'fx-brand-name', text: m.marca }),
              h('span', { class: 'fx-brand-meta', text: 'hasta ' + m.hasta + ' €' })
            ]);
            chip.addEventListener('click', function () {
              marcaActiva = (marcaActiva === m.marca) ? null : m.marca;
              marcas.querySelectorAll('.fx-brand').forEach(function (c) {
                c.setAttribute('aria-pressed', 'false');
              });
              if (marcaActiva) chip.setAttribute('aria-pressed', 'true');
              input.value = '';
              buscar('');
            });
            marcas.appendChild(chip);
          });
        }).catch(function () { /* sin filtros se sigue pudiendo buscar */ });
      }

      function buscar(q) {
        resultados.innerHTML = '';
        resultados.appendChild(h('div', { class: 'fx-skeleton' }));
        var url = '/api/recompra/modelos?q=' + encodeURIComponent(q);
        if (marcaActiva) url += '&marca=' + encodeURIComponent(marcaActiva);
        if (tipoActivo) url += '&tipo=' + encodeURIComponent(tipoActivo);
        get(url).then(function (data) {
          resultados.innerHTML = '';
          // El servicio puede estar cerrado a proposito (puesta en marcha
          // incompleta): mejor decirlo que mostrar un error tecnico.
          if (data && data.cerrado) {
            resultados.appendChild(h('div', { class: 'fx-note', text: data.error }));
            return;
          }
          var lista = (data && data.modelos) || [];
          if (!lista.length) {
            var filtro = [marcaActiva, tipoActivo ? tipoActivo.toLowerCase() : null]
              .filter(Boolean).join(' · ');
            resultados.appendChild(h('div', {
              class: 'fx-note',
              text: filtro
                ? 'No tenemos nada de ' + filtro + ' que encaje con esa búsqueda.'
                : 'No encontramos ese modelo. Escríbenos por WhatsApp y lo valoramos a mano.'
            }));
            return;
          }
          lista.forEach(function (m) {
            var b = h('button', { type: 'button', class: 'fx-result' }, [
              h('strong', { text: nombreModelo(m) }),
              h('span', { text: 'hasta ' + Math.round(m.hasta) + ' €' })
            ]);
            b.addEventListener('click', function () { elegirModelo(m); });
            resultados.appendChild(b);
          });
        }).catch(function () {
          // Fallo de red o CORS: el cliente no tiene por que ver un error.
          resultados.innerHTML = '';
          resultados.appendChild(h('div', { class: 'fx-note', text: MENSAJE_NO_DISPONIBLE }));
        });
      }

      input.addEventListener('input', function () {
        clearTimeout(buscarTimer);
        var q = input.value.trim();
        buscarTimer = setTimeout(function () { buscar(q); }, 220);
      });

      state.idx = -1;
      pintar([
        h('p', { class: 'fx-q', text: '¿Qué dispositivo quieres vender?' }),
        h('p', { class: 'fx-help', text: 'Te damos el precio en menos de un minuto, sin compromiso.' }),
        h('div', { class: 'fx-search' }, [input]),
        tipos,
        marcas,
        resultados
      ]);
      input.focus({ preventScroll: true });
      pintarCategorias();
      buscar('');
    }

    function elegirModelo(m) {
      state.modelo = m;
      state.respuestas = {};
      get('/api/recompra/cuestionario?slug=' + encodeURIComponent(m.slug))
        .then(function (data) {
          if (data && data.cerrado) return error(data.error);
          if (!data || !data.ok) throw new Error('cuestionario');
          state.preguntas = data.preguntas || [];
          state.tiendas = (data.tiendas && data.tiendas.length) ? data.tiendas : TIENDAS_FALLBACK;
          state.validez = data.validez_dias || 14;
          state.idx = 0;
          pintarPregunta();
        })
        .catch(function () { error('No hemos podido cargar el cuestionario.'); });
    }

    // ----------------------------------------------------- paso: preguntas
    function pintarPregunta() {
      var q = state.preguntas[state.idx];
      if (!q) return pantallaPrecio();

      var multi = q.type === 'multi';
      var seleccion = state.respuestas[q.id] || (multi ? [] : null);
      var opciones = h('div', { class: 'fx-options', role: multi ? 'group' : 'radiogroup' });
      // El boton de una pregunta multiple cambia de significado segun lo
      // marcado: "todo funciona bien" solo es cierto si no hay nada marcado.
      var botonSeguir = null;

      function etiquetaSeguir() {
        if (!multi) return 'Continuar';
        if (!seleccion.length) return 'Todo funciona bien';
        return seleccion.length === 1 ? 'Continuar con 1 fallo'
                                      : 'Continuar con ' + seleccion.length + ' fallos';
      }

      function refrescarSeguir() {
        if (botonSeguir) botonSeguir.textContent = etiquetaSeguir();
      }

      (q.options || []).forEach(function (o) {
        var activo = multi ? seleccion.indexOf(o.value) !== -1 : seleccion === o.value;
        var b = h('button', {
          type: 'button', class: 'fx-opt', 'aria-pressed': activo ? 'true' : 'false',
          'data-multi': multi ? '1' : '0'
        }, [
          h('span', { class: 'fx-check', 'aria-hidden': 'true' }),
          h('span', { class: 'fx-opt-body' }, [
            h('span', { class: 'fx-opt-label', text: o.label }),
            o.hint ? h('span', { class: 'fx-opt-hint', text: o.hint }) : null
          ])
        ]);
        b.addEventListener('click', function () {
          if (multi) {
            var i = seleccion.indexOf(o.value);
            if (i === -1) seleccion.push(o.value); else seleccion.splice(i, 1);
            state.respuestas[q.id] = seleccion;
            b.setAttribute('aria-pressed', seleccion.indexOf(o.value) !== -1 ? 'true' : 'false');
            refrescarSeguir();
          } else {
            state.respuestas[q.id] = o.value;
            avanzar();
          }
        });
        opciones.appendChild(b);
      });

      var nodos = [
        h('p', { class: 'fx-q', text: q.label }),
        q.help ? h('p', { class: 'fx-help', text: q.help }) : null,
        opciones
      ].filter(Boolean);

      var botones = [btn('Atrás', 'fx-btn fx-btn-ghost', retroceder), h('span', { class: 'fx-spacer' })];
      if (multi) {
        botonSeguir = btn(etiquetaSeguir(), 'fx-btn', avanzar);
        botones.push(botonSeguir);
      }
      nodos.push(nav(botones));
      pintar(nodos);
    }

    function avanzar() {
      state.idx += 1;
      if (state.idx >= state.preguntas.length) pantallaPrecio();
      else pintarPregunta();
    }

    function retroceder() {
      state.idx -= 1;
      if (state.idx < 0) pantallaBusqueda();
      else pintarPregunta();
    }


  // Nombre del aparato con su variante. No todo se mide en GB: un Apple Watch
  // va en milimetros y unos AirPods no tienen variante ninguna, asi que ahi no
  // se escribe nada en vez de un "0 u" que no significa nada.
  function etiquetaAparato(o) {
    var unidad = o.unidad || 'GB';
    if (unidad === 'u' || !o.capacidad_gb) return o.modelo;
    return o.modelo + ' · ' + o.capacidad_gb + ' ' + unidad;
  }

    // -------------------------------------------------------- paso: precio
    function pantallaPrecio() {
      pintar([h('div', { class: 'fx-skeleton', style: 'height:180px' })]);
      post('/api/recompra/tasar', {
        slug: state.modelo.slug,
        respuestas: state.respuestas
      }).then(function (data) {
        if (data && data.rechazado) return pantallaRechazo(data.motivo);
        if (!data || !data.ok) return error(data && data.error);
        state.oferta = data;

        var tarjeta = h('div', { class: 'fx-price-card' }, [
          h('div', { class: 'fx-model', text: etiquetaAparato(data) }),
          h('div', { class: 'fx-price', text: formato(data.precio) }),
          h('span', { class: 'fx-grade', text: 'Estado estimado: ' + data.grado_label }),
          h('p', {
            class: 'fx-validez',
            text: 'Precio garantizado ' + data.validez_dias + ' dias si el estado coincide con lo que nos has indicado.'
          })
        ]);

        pintar([
          tarjeta,
          h('div', {
            class: 'fx-note',
            text: 'Al recibirlo lo revisamos en 24-48 h laborables. Si todo coincide, te pagamos este importe. Si no, te enviamos una contraoferta que puedes rechazar: en ese caso te lo devolvemos gratis.'
          }),
          nav([
            btn('Atrás', 'fx-btn fx-btn-ghost', function () { state.idx = state.preguntas.length - 1; pintarPregunta(); }),
            h('span', { class: 'fx-spacer' }),
            btn('Aceptar y vender', 'fx-btn', pantallaFormulario)
          ])
        ]);
      }).catch(function () { error(); });
    }

    function pantallaRechazo(motivo) {
      pintar([
        h('div', { class: 'fx-note fx-bad', text: motivo || 'No podemos tasar este dispositivo online.' }),
        h('p', { class: 'fx-help', text: 'Si crees que es un error, pasate por tienda y lo valoramos en mano.' }),
        nav([btn('Volver', 'fx-btn fx-btn-ghost', function () { state.idx = state.preguntas.length - 1; pintarPregunta(); })])
      ]);
    }

    // ---------------------------------------------------- paso: formulario
    function campo(id, etiqueta, attrs, ayuda) {
      var input = h('input', Object.assign({ id: 'fx-' + id, name: id, type: 'text' }, attrs || {}));
      return h('div', { class: 'fx-field', 'data-field': id }, [
        h('label', { for: 'fx-' + id, text: etiqueta }),
        input,
        ayuda ? h('small', { text: ayuda }) : null
      ]);
    }

    function pantallaFormulario() {
      var entrega = h('div', { class: 'fx-options' });
      var elegida = { valor: 'recogida', tienda: state.tiendas[0] };

      var bloqueDireccion = h('div', { class: 'fx-fields' }, [
        campo('direccion', 'Direccion de recogida', { autocomplete: 'street-address' }),
        campo('cp', 'Codigo postal', { inputmode: 'numeric', autocomplete: 'postal-code' }),
        campo('ciudad', 'Ciudad', { autocomplete: 'address-level2' }),
        campo('provincia', 'Provincia', { autocomplete: 'address-level1' })
      ]);
      var selTienda = h('select', { id: 'fx-tienda', name: 'tienda' });
      state.tiendas.forEach(function (t) { selTienda.appendChild(h('option', { value: t, text: t })); });
      var bloqueTienda = h('div', { class: 'fx-fields' }, [
        h('div', { class: 'fx-field fx-wide' }, [
          h('label', { for: 'fx-tienda', text: 'Elige tienda' }), selTienda
        ])
      ]);
      bloqueTienda.hidden = true;

      [['recogida', 'Recogida gratuita a domicilio', 'Te enviamos la etiqueta prepagada'],
       ['tienda', 'Lo llevo a una tienda Fixel', 'Revision y pago en el momento']
      ].forEach(function (opt, i) {
        var b = h('button', {
          type: 'button', class: 'fx-opt', 'data-multi': '0',
          'aria-pressed': i === 0 ? 'true' : 'false'
        }, [
          h('span', { class: 'fx-check', 'aria-hidden': 'true' }),
          h('span', { class: 'fx-opt-body' }, [
            h('span', { class: 'fx-opt-label', text: opt[1] }),
            h('span', { class: 'fx-opt-hint', text: opt[2] })
          ])
        ]);
        b.addEventListener('click', function () {
          elegida.valor = opt[0];
          entrega.querySelectorAll('.fx-opt').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          bloqueDireccion.hidden = opt[0] !== 'recogida';
          bloqueTienda.hidden = opt[0] !== 'tienda';
        });
        entrega.appendChild(b);
      });

      var datos = h('div', { class: 'fx-fields' }, [
        campo('nombre', 'Nombre', { autocomplete: 'given-name' }),
        campo('apellidos', 'Apellidos', { autocomplete: 'family-name' }),
        campo('email', 'Email', { type: 'email', autocomplete: 'email' }),
        campo('telefono', 'Telefono', { type: 'tel', autocomplete: 'tel' }),
        campo('dni', 'DNI o NIE', {}, 'Obligatorio por ley para comprar dispositivos de segunda mano'),
        campo('fecha_nacimiento', 'Fecha de nacimiento', { type: 'date' }, 'Solo compramos a mayores de edad'),
        campo('iban', 'IBAN para el pago', { placeholder: 'ES00 0000 0000 0000 0000 0000' }, 'Opcional si entregas en tienda'),
        campo('imei', 'IMEI o numero de serie', {}, 'Opcional, agiliza la revision')
      ]);

      var consent = h('label', { class: 'fx-consent' }, [
        h('input', { type: 'checkbox', id: 'fx-rgpd' }),
        h('span', {
          html: 'Acepto que Fixel trate mis datos para gestionar la compraventa y para cumplir la obligacion legal de registro de bienes usados. He leido la <a href="/policies/privacy-policy" target="_blank" rel="noopener">politica de privacidad</a>.'
        })
      ]);

      var hp = h('input', { class: 'fx-hp', tabindex: '-1', 'aria-hidden': 'true', name: 'website' });
      var alerta = h('p', { class: 'fx-alert', role: 'alert', hidden: 'hidden' });
      var enviar = btn('Confirmar la venta', 'fx-btn', function () { enviarFormulario(enviar, alerta, elegida, hp); });

      pintar([
        h('div', { class: 'fx-price-card' }, [
          h('div', { class: 'fx-model', text: etiquetaAparato(state.oferta) }),
          h('div', { class: 'fx-price', text: formato(state.oferta.precio) })
        ]),
        h('p', { class: 'fx-q', text: '¿Como quieres entregarlo?' }),
        entrega, bloqueDireccion, bloqueTienda,
        h('p', { class: 'fx-q', style: 'margin-top:26px', text: 'Tus datos' }),
        datos, consent, hp, alerta,
        nav([btn('Atrás', 'fx-btn fx-btn-ghost', pantallaPrecio), h('span', { class: 'fx-spacer' }), enviar])
      ]);
    }

    function enviarFormulario(boton, alerta, elegida, hp) {
      var val = function (id) {
        var n = pane.querySelector('#fx-' + id);
        return n ? n.value.trim() : '';
      };
      pane.querySelectorAll('.fx-field').forEach(function (f) { f.classList.remove('fx-error'); });
      alerta.hidden = true;

      var cliente = {
        nombre: val('nombre'), apellidos: val('apellidos'), email: val('email'),
        telefono: val('telefono'), dni: val('dni'), fecha_nacimiento: val('fecha_nacimiento'),
        direccion: val('direccion'), cp: val('cp'), ciudad: val('ciudad'),
        provincia: val('provincia'), iban: val('iban'), imei: val('imei'),
        entrega: elegida.valor,
        tienda: elegida.valor === 'tienda' ? val('tienda') : '',
        rgpd_consent: !!pane.querySelector('#fx-rgpd').checked
      };

      boton.disabled = true;
      boton.textContent = 'Enviando…';

      post('/api/recompra/expediente', {
        slug: state.modelo.slug,
        respuestas: state.respuestas,
        cliente: cliente,
        hp: hp.value,
        elapsed: (Date.now() - state.inicio) / 1000
      }).then(function (data) {
        boton.disabled = false;
        boton.textContent = 'Confirmar la venta';
        if (data && data.ok) return pantallaFin(data, elegida.valor);
        if (data && data.rechazado) return pantallaRechazo(data.motivo);
        if (data && data.campo) {
          var f = pane.querySelector('[data-field="' + data.campo + '"]');
          if (f) { f.classList.add('fx-error'); f.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        }
        alerta.textContent = (data && data.error) || 'Revisa los datos e intentalo de nuevo.';
        alerta.hidden = false;
      }).catch(function () {
        boton.disabled = false;
        boton.textContent = 'Confirmar la venta';
        alerta.textContent = 'No hemos podido enviar la solicitud. Intentalo en un momento.';
        alerta.hidden = false;
      });
    }

    function pantallaFin(data, entrega) {
      var siguiente = entrega === 'tienda'
        ? 'Pasate por la tienda con el dispositivo y tu DNI. Lo revisamos delante de ti y te pagamos en el momento.'
        : 'Te hemos enviado por email la etiqueta de envio prepagada. Empaqueta el dispositivo y entregalo al mensajero.';
      bar.style.width = '100%';
      label.textContent = 'Listo';
      pane.innerHTML = '';
      pane.appendChild(h('div', { class: 'fx-price-card' }, [
        h('div', { class: 'fx-model', text: 'Expediente ' + data.ref }),
        h('div', { class: 'fx-price', text: formato(data.precio) }),
        h('span', { class: 'fx-grade', text: 'Valido hasta ' + data.valido_hasta })
      ]));
      pane.appendChild(h('div', { class: 'fx-note', text: siguiente }));
      pane.appendChild(h('p', {
        class: 'fx-help',
        text: 'Guarda tu referencia ' + data.ref + '. Puedes seguir el estado en cualquier momento desde el enlace que te hemos enviado por email.'
      }));
      pane.appendChild(nav([btn('Vender otro dispositivo', 'fx-btn fx-btn-ghost', function () {
        state.oferta = null; state.inicio = Date.now(); pantallaBusqueda();
      })]));
    }

    // -------------------------------------------------------------- varios
    function formato(n) {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency', currency: 'EUR', maximumFractionDigits: 0
      }).format(n);
    }

    function error(msg) {
      pintar([
        h('div', { class: 'fx-note fx-bad', text: msg || 'Algo no ha ido bien. Vuelve a intentarlo.' }),
        nav([btn('Empezar de nuevo', 'fx-btn fx-btn-ghost', pantallaBusqueda)])
      ]);
    }

    pantallaBusqueda();
  }

  function boot() {
    document.querySelectorAll('[data-fx-tasador]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Reinicializa al editar la seccion en el editor de temas.
  document.addEventListener('shopify:section:load', boot);
})();
